let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4R0t")).then(() => parcelRequire('gaQou'));